"use strict";

var _classCallCheck = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Configuration_1 = __importDefault(require("./Configuration"));

var ApiCall_1 = __importDefault(require("./ApiCall"));

var Collections_1 = __importDefault(require("./Collections"));

var Collection_1 = __importDefault(require("./Collection"));

var Aliases_1 = __importDefault(require("./Aliases"));

var Alias_1 = __importDefault(require("./Alias"));

var Keys_1 = __importDefault(require("./Keys"));

var Key_1 = __importDefault(require("./Key"));

var Debug_1 = __importDefault(require("./Debug"));

var Metrics_1 = __importDefault(require("./Metrics"));

var Health_1 = __importDefault(require("./Health"));

var Operations_1 = __importDefault(require("./Operations"));

var MultiSearch_1 = __importDefault(require("./MultiSearch"));

var Client = /*#__PURE__*/function () {
  function Client(options) {
    _classCallCheck(this, Client);

    this.configuration = new Configuration_1.default(options);
    this.apiCall = new ApiCall_1.default(this.configuration);
    this.debug = new Debug_1.default(this.apiCall);
    this.metrics = new Metrics_1.default(this.apiCall);
    this.health = new Health_1.default(this.apiCall);
    this.operations = new Operations_1.default(this.apiCall);
    this.multiSearch = new MultiSearch_1.default(this.apiCall, this.configuration);
    this._collections = new Collections_1.default(this.apiCall);
    this.individualCollections = {};
    this._aliases = new Aliases_1.default(this.apiCall);
    this.individualAliases = {};
    this._keys = new Keys_1.default(this.apiCall);
    this.individualKeys = {};
  }

  _createClass(Client, [{
    key: "collections",
    value: function collections(collectionName) {
      if (collectionName === undefined) {
        return this._collections;
      } else {
        if (this.individualCollections[collectionName] === undefined) {
          this.individualCollections[collectionName] = new Collection_1.default(collectionName, this.apiCall, this.configuration);
        }

        return this.individualCollections[collectionName];
      }
    }
  }, {
    key: "aliases",
    value: function aliases(aliasName) {
      if (aliasName === undefined) {
        return this._aliases;
      } else {
        if (this.individualAliases[aliasName] === undefined) {
          this.individualAliases[aliasName] = new Alias_1.default(aliasName, this.apiCall);
        }

        return this.individualAliases[aliasName];
      }
    }
  }, {
    key: "keys",
    value: function keys(id) {
      if (id === undefined) {
        return this._keys;
      } else {
        if (this.individualKeys[id] === undefined) {
          this.individualKeys[id] = new Key_1.default(id, this.apiCall);
        }

        return this.individualKeys[id];
      }
    }
  }]);

  return Client;
}();

exports.default = Client;